// Fuente unica de verdad para los modulos del sistema de permisos.
// Las `key` deben coincidir EXACTO con MODULO_KEYS en
// backend/app/models/permisos.py (cargos_pagos, servicios_precios,
// mensajes_contacto - no las formas cortas "cargos"/"servicios"/"mensajes")
// porque GET /users/me/permisos usa esas llaves reales.
import React from "react";

export const MODULOS = [
  { key: "pacientes", label: "Pacientes", icon: <i className="fa-solid fa-user" />, path: "/app/pacientes" },
  { key: "agenda", label: "Agenda", icon: <i className="fa-solid fa-calendar-days" />, path: "/app/agenda" },
  { key: "cargos_pagos", label: "Cargos y Pagos", icon: <i className="fa-solid fa-file-invoice-dollar" />, path: "/app/cargos" },
  { key: "servicios_precios", label: "Servicios y precios", icon: <i className="fa-solid fa-tags" />, path: "/app/servicios" },
  { key: "lentes", label: "Lentes", icon: <i className="fa-solid fa-glasses" />, path: "/app/lentes" },
  { key: "colegas", label: "Colegas", icon: <i className="fa-solid fa-user-doctor" />, path: "/app/colegas" },
  { key: "aseguradoras", label: "Aseguradoras", icon: <i className="fa-solid fa-building-shield" />, path: "/app/aseguradoras" },
  { key: "mensajes_contacto", label: "Mensajes de contacto", icon: <i className="fa-solid fa-envelope" />, path: "/app/mensajes" },
  { key: "usuarios", label: "Usuarios", icon: <i className="fa-solid fa-user-gear" />, path: "/app/usuarios" },
  { key: "configuracion", label: "Configuracion", icon: <i className="fa-solid fa-gear" />, path: "/app/configuracion" },
];

export const MODULO_KEYS = MODULOS.map((m) => m.key);

export const MODULOS_BY_KEY = Object.fromEntries(MODULOS.map((m) => [m.key, m]));

export const ACTIONS = [
  { key: "modulo", label: "Modulo" },
  { key: "consultar", label: "Consultar" },
  { key: "insertar", label: "Insertar" },
  { key: "editar", label: "Editar" },
  { key: "eliminar", label: "Eliminar" },
];

export const ACTION_KEYS = ACTIONS.map((a) => a.key);
